import React from 'react';
import { 
  Dialog, 
  DialogActions, 
  DialogContent, 
  DialogTitle, 
  Button, 
  Typography,
  Box, 
  TextField,
  Divider,
  FormControlLabel,
  Checkbox,
  CircularProgress,
} from '@mui/material';

import { Catalogs } from '../../../controllers';
import { SimpleValidators } from '../../../utils';

export default function CsvDialog({ open, onClose, onConfirm }) {

  const [loading, isLoading] = React.useState(false);

  const [checks, setChecks] = React.useState([]);
  const [status, setStatus] = React.useState(undefined);
  const [dates, setDates] = React.useState({
    from  : SimpleValidators.Dates(),
    to    : SimpleValidators.Dates()
  });
  const [error, setError] = React.useState({
    dates   : false,
    status  : false
  });



  React.useEffect(() => {
    handleLoad();
  },[]);

  React.useEffect(() => {
    validateDates();
  },[dates]);

  React.useEffect(() => {
    if(status === undefined){
      return;
    }

    validateStatuses(); 
  },[status]);

  const handleLoad = async() => {
    getStatus();
    
  }

  const handleDate = async(e) => {
    setDates({...dates,[e.target.name] : e.target.value});
  }

  const handleStatus = async (e) => {
    setStatus({...status, [e.target.name] : {...status[e.target.name], status: e.target.checked}});
  }

  const handleClose = async() => {
    if(loading){
      return;
    }

    var statusReset = {...status}
    var datesReset = {...dates};

    Object.keys(statusReset).forEach(x => {
      statusReset[x].status = true;
    });

    Object.keys(datesReset).forEach(x => {
      datesReset[x] = SimpleValidators.Dates();
    });

    setStatus(statusReset);
    setDates(datesReset);
    setError({status: false, dates: false});
    onClose();
  }

  const handleConfirm = async() => {
    var statuses = [];
    var date = [dates.from, dates.to];

    Object.keys(status).forEach(x => {
      if(status[x].status){
        statuses.push(status[x].value);
      }
    });

    onConfirm(date, statuses, getResponse);
    isLoading(true);
  }

  const getStatus = async() => {
    if(checks.length > 0){
      return;
    }

    const response = await Catalogs.OrderValidStatuses();

    if(!response.success){
      console.log(response.message);
      return;
    }

    var statuses = {};
    response.result.forEach(x => {
      statuses = {...statuses, [x.name] : {status: true, value: x.id}};
    });

    setStatus(statuses);
    setChecks(response.result);
  }

  const validateDates = async() => {
    const result =  dates.from > dates.to;
    setError({...error, dates: result});
  }

  const validateStatuses = async() => {
    var result = true;
    
    Object.keys(status).forEach(x => {
      if(status[x].status){
        result = false;
        return;
      }
    });

    setError({...error, status: result});
  }

  const getResponse = async(response) => {
    isLoading(false);

    if(response.success){
      handleClose();
      return;
    }

    alert(response.message);
  }

  return (
    <Dialog open={open} onClose={handleClose} sx={{minWidth:'50vw'}}>
      <DialogTitle >CSV Report</DialogTitle>
      <Divider />
      <DialogContent>
      <Box
        sx={{
          display:'flex',
          flexDirection: 'column',
        }}
      >
        <Typography variant='body1' >
          Date Range
        </Typography>
        <Divider />
        <Box
          sx={{
            gap:2,
            padding:2,
            display:'flex',
            flexDirection: 'row',
            justifyContent: 'space-between'
          }}
        >
          <TextField size='small' type='date' fullWidth name='from' onChange={handleDate} value={dates.from}/>
          <TextField size='small' type='date' fullWidth name='to'onChange={handleDate} value={dates.to}/>
        </Box>
        
        <Box
          sx={{
            display:'flex',
            flexDirection: 'row',
          }}
        >
          <Typography variant='body1' >
            Order Status
          </Typography>
        </Box>
        <Divider />
        <Box
          sx={{
            gap:1,
            display:'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            flexWrap: 'wrap'
          }}
        >
          {checks.length > 0 && checks.map((item) => (
            <FormControlLabel control={<Checkbox name={item.name} value={item.id} onChange={handleStatus} defaultChecked/>} label={item.name} />
          ))}
        </Box>
      </Box>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Typography
          sx={{
            fontSize:12,
            color:'red'
          }}
        >
          {error.dates ? 'Invalid Dates' : ''}
          <br/>
          {error.status ? 'Require 1 STATUS minimum ' : ''}
        </Typography>
        
        {loading && (
          <CircularProgress />
        )}

        <Button onClick={handleClose} color='secondary' variant='contained' disabled={loading}>Cancel</Button>
        <Button onClick={handleConfirm} variant='contained' disabled={error.dates || error.status || loading}>Create CSV</Button>
        
      </DialogActions>
    </Dialog>
  );
}